import React from 'react';
import { Row, Col, Image } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Title } from '@/components/Typography';
import { useRosaResultContext } from '../context';
import { ImageContainer, ImageCard } from './styles';

export const ImagesList: React.FC = () => {
	const {
		rosaResult: { images }
	} = useRosaResultContext();

	if (images.length === 0) {
		return <></>;
	}

	return (
		<Row gutter={[0, 20]}>
			<Col xs={24}>
				<Title level={3}>{I18n.get('Images')}</Title>
			</Col>
			<Col span={24}>
				{images.map((image) => (
					<Row key={image.url} justify="center" gutter={[0, 20]}>
						<Col xs={12}>
							<ImageContainer>
								<Image src={image.url} />
							</ImageContainer>
						</Col>
						<Col xs={12}>
							<ImageCard title={I18n.get('Description')} bordered={false}>
								{image.description ? image.description : 'N/A'}
							</ImageCard>
						</Col>
					</Row>
				))}
			</Col>
		</Row>
	);
};
